import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { LayoutCard } from '@/components/layout/card.tsx';
import { BackButton } from '@/components/page-header/back-button.tsx';
import { DrawerAvatarTrigger } from '@/components/page-header/drawer-avatar-trigger.tsx';
import {
  infoContainer,
  richHeader,
  richHeaderDescription,
  richHeaderTitle,
  titleContainer,
  topLineContainer,
} from '@/components/page-header/page-rich-header.css.ts';

type PageRichHeaderProps = {
  title: ReactNode;
  titleAside?: ReactNode;
  description: string;
  contentUnderTitle?: ReactNode;
  filters?: ReactNode;
  fallbackReturnTo?: string;
  className?: string;
  topLineClassName?: string;
};

export const PageRichHeader: React.FC<
  React.PropsWithChildren<PageRichHeaderProps>
> = ({
  children,
  className,
  topLineClassName,
  title,
  titleAside,
  contentUnderTitle,
  description,
  filters,
  fallbackReturnTo,
}) => {
  const isTablet = useIsTablet();
  const Container = isTablet ? LayoutCard : 'div';

  return (
    <Container className={richHeader}>
      <div className={className}>
        <div className={infoContainer}>
          <div className={clsx(topLineContainer, topLineClassName)}>
            <div className={titleContainer}>
              {!isTablet ? (
                <BackButton fallbackReturnTo={fallbackReturnTo} />
              ) : null}
              <h2 className={richHeaderTitle}>{title}</h2>
              {isTablet && titleAside}
            </div>
            {!isTablet ? <DrawerAvatarTrigger /> : null}
          </div>
          {contentUnderTitle}
          <span className={richHeaderDescription}>{description}</span>
        </div>
        {!isTablet && titleAside}
        {children}
      </div>
      {filters}
    </Container>
  );
};
